import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ThemeSettingsService } from '../shared/services/theme-settings.service';
import { TranslateService } from '@ngx-translate/core';

@Component( {
  selector: 'app-ui-setting',
  templateUrl: './ui-setting.component.html',
  styleUrls: ['./ui-setting.component.scss']
} )
export class UiSettingComponent implements OnInit {
  @ViewChild( 'controlMenu' ) controlMenu: TemplateRef<any>;
  @ViewChild( 'titlePage' ) titlePage: TemplateRef<any>;
  title = 'Theam Settings';
  theme: string;

  themes = ['indigo-pink', 'deeppurple-amber', 'pink-bluegrey', 'purple-green', 'dark-theme', 'candy-theme'];


  constructor ( public translate: TranslateService, private themeService: ThemeSettingsService ) { }

  ngOnInit () {
  }

  updateTheme ( theme ) {
    this.themeService.changeTheme( theme );
  }

}



// WEBPACK FOOTER //
// ./src/app/ui-setting/ui-setting.component.ts